import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `AlbaranManual/editAlbaran`, method: 'POST', body: values, token: token})
}
